import React, { useState } from 'react';

import '../../styles/components/_section.scss';
import Nati from '../../images/Nati_circle.jpg';

import Nicky from '../../images/nicky_circle.jpg';
import Nico from '../../images/nico_circle.jpg';
import { FaLinkedin } from "react-icons/fa";

const teamMembers = [

  {
    name: 'Natalia S. Wensioe',
    title: 'Chief Excutive Officer | Founder',
    image: Nati,
    description:
      'Design and Mechanical Engineer specializing in hardware and mechanical systems. She is responsible for the physical architecture of Hero Dynamics\' biomimetic platforms, ensuring each design is both functional and resilient in extreme environments.',
    linkedin: 'https://www.linkedin.com/in/natalia-wensioe-valenzuela-128665227/',
    photoClass: 'smaller-img'
  },
  {
    name: 'Nicomedes Pommier',
    title: 'Chief Technology Officer | Founder',
    image: Nico,
    description:
      'Design and Mechanical Engineer with a master\'s degree in Engineering Sciences. Focused on software development, control systems, and advanced research, he leads the technological innovation at Hero Dynamics, integrating deep scientific understanding with cutting-edge engineering.',
    linkedin: 'https://www.linkedin.com/in/nicomedes-pommier-b90b7a1b1/',
    photoClass: ''
  },
  {
    name: 'Nicole A. Castro',
    title: 'Chief Operating Officer | Founder',
    image: Nicky,
    description:
      'Bioengineer with expertise in biomaterials, ecological systems, and sustainable development. She oversees biological integration, ecological impact assessment, and ensures that Hero Dynamics’ technologies remain environmentally responsible and scientifically rigorous.',
    linkedin: 'https://www.linkedin.com/in/nicole-antonia-castro/',
    photoClass: 'smaller-img'
  },
];

const Team = () => {
  const [expandedCard, setExpandedCard] = useState(null);

  const toggleExpand = (index) => {
    setExpandedCard(expandedCard === index ? null : index);
  };

  return (
    <section className="team-section">
      <h2>Meet the founders</h2>
      <div className="team-cards">
        {teamMembers.map((member, index) => {
          const isExpanded = expandedCard === index;
          const shortDescription = member.description.slice(0, 120) + '...';

          return (
            <div className={`team-card ${isExpanded ? 'expanded' : ''}`} key={index}>
              <div className="card-photo">
                <img
                  src={member.image}
                  alt={member.name}
                  className={`team-photo ${member.photoClass || ''}`}
                />
              </div>

              <div className="card-info">
                <span>{member.title}</span>
                <h3>{member.name}</h3>
                <p>{isExpanded ? member.description : shortDescription}</p>
                <button className="read-more" onClick={() => toggleExpand(index)}>
                  {isExpanded ? 'Show less' : 'Read more'}
                </button>
              </div>

              <div className="card-socials">
                {member.linkedin && (
                  <a href={member.linkedin} target="_blank" rel="noopener noreferrer">
                    <FaLinkedin />
                  </a>
                )}
              </div>
            </div>
          );
        })}
      </div>
    </section>
  );
};

export default Team;
